import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guard used to clear the existing authentication session
 * before allowing navigation to the sign-in page.
 */
export const logoutGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  authService.logout();
  return true;
};